import { Grid, Typography } from '@mui/material';
import { Column } from 'further-ui/components/Layout';
import { numberToDisplayString } from 'further-ui/utils';

type CurrentValuationRowProps = {
  currentValuation: {
    currentHoldValue: string;
    averageUnitPriceTcy: string;
    latestRevaluationDate: string;
    currentNumberOfUnits: number;
  };
  newValuation: {
    holdValue: string;
    averageUnitPriceTcy: string;
    numberOfUnits: number;
    revaluationDate: string;
  };
};

const CurrentValuationRow: React.FC<CurrentValuationRowProps> = ({
  currentValuation: {
    currentHoldValue,
    averageUnitPriceTcy,
    latestRevaluationDate,
    currentNumberOfUnits,
  },
  newValuation,
}) => {
  return (
    <Column spacing="sm">
      <Grid container spacing={2}>
        <Grid size="grow"></Grid>
        <Grid size="grow">
          <Typography variant="h6">Total hold value</Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="h6">Average unit price</Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="h6">Units held</Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="h6">Revaluation date</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid size="grow">
          <Typography variant="h6" color="grey.600">
            Current valuation
          </Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="body2" color="grey.900">
            {currentHoldValue}
          </Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="body2" color="grey.900">
            {averageUnitPriceTcy}
          </Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="body2" color="grey.900">
            {numberToDisplayString(currentNumberOfUnits)}
          </Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="body2" color="grey.900">
            {latestRevaluationDate}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid size="grow">
          <Typography variant="h6" color="grey.600">
            New valuation
          </Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="body2" color="grey.900">
            {newValuation.holdValue}
          </Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="body2" color="grey.900">
            {newValuation.averageUnitPriceTcy}
          </Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="body2" color="grey.900">
            {numberToDisplayString(newValuation.numberOfUnits)}
          </Typography>
        </Grid>
        <Grid size="grow">
          <Typography variant="body2" color="grey.900">
            {newValuation.revaluationDate}
          </Typography>
        </Grid>
      </Grid>
    </Column>
  );
};

export default CurrentValuationRow;
